/*
 * @Date: 2023-12-07 16:35:58
 * @LastEditors: shizheng 64840669+code-cola-js@users.noreply.github.com
 * @LastEditTime: 2023-12-07 16:36:03
 * @FilePath: \hisea-ssr\src\components\RadioGroup\MyContext.js
 */
import React from "react";

const MyContext = React.createContext();

export default MyContext;
